import { createContext } from 'react';

export const GoToMarkerContext = createContext(0);
